import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import AnimatedBackground from "@/components/AnimatedBackground";
import { Button } from "@/components/ui/button";
import { Clock, Scissors } from "lucide-react";
import { Link } from "react-router-dom";
import hairImage from "@/assets/friseur-haarstyling-nuernberg.webp";
import herrenClipper from "@/assets/herrenhaarschnitt-clipper-nuernberg.webp";
import barberStylist from "@/assets/barber-herrenfriseur-22studios-nuernberg.webp";
import herrenSchnitt from "@/assets/maennerhaarschnitt-friseur-nuernberg.webp";
import SEO from "@/components/SEO";

import { getPlanityUrl } from "@/config/standort";

// Damen Preise – Nürnberg (Original)
const damenPreiseNuernberg = [
  { name: "Waschen, Fönen, Stylen", price: "ab 36 €" },
  { name: "Coloration", price: "ab 46 €" },
  { name: "Tönung", price: "ab 38 €" },
  { name: "Glossing", price: "ab 27 €" },
  { name: "Strähnen", price: "ab 75 €*" },
  { name: "Balayage", price: "ab 120 €*" },
];

// Damen Preise




const HaarePage = () => {
  const basePath = "/nuernberg";
  const PLANITY_URL = getPlanityUrl();

  const heroImage = hairImage;

  return (
    <main className="min-h-screen bg-background relative">
      <SEO
        title="Friseur Nürnberg – Balayage & Haarschnitt | 22 Studios"
        description="Professioneller Friseur in Nürnberg: Balayage, Haare schneiden, färben & Spitzen schneiden mit Paul Mitchell Produkten. Augenbrauen färben inklusive. Termin buchen!"
        canonical="https://22studios.de/nuernberg/haare"
      />
      <AnimatedBackground />
      <Navigation />

      {/* Hero Section */}
      <section className="pt-24 pb-10 md:pt-40 md:pb-24 relative z-10">
        <div className="container px-4 md:px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-20 items-center">
            <div className="space-y-4 md:space-y-6">
              <div className="space-y-3 md:space-y-4">
                <span className="text-sm tracking-wide uppercase text-label font-medium">
                  Friseur &amp; Haarstyling
                </span>
                <h1 className="text-display md:text-display-lg font-serif font-light text-foreground">
                  Haare &amp; Styling
                </h1>
              </div>
              <p className="text-base md:text-lg text-muted-foreground font-light leading-relaxed">
                {"Dein Friseur in Nürnberg für Balayage, Haare schneiden, Haare färben, Spitzen schneiden und Augenbrauen färben. Wir verwenden exklusive Paul Mitchell Produkte für gesundes, glänzendes Haar – individuell abgestimmt auf deinen Stil."}
              </p>
              <div className="flex flex-wrap gap-2">
                {["Balayage", "Haare schneiden", "Haare färben", "Spitzen schneiden"].map((tag) => (
                  <span key={tag} className="px-3 py-1 text-xs font-medium rounded-full bg-secondary/50 text-muted-foreground border border-border/30">
                    {tag}
                  </span>
                ))}
              </div>
                <Button
                  size="lg"
                  className="bg-primary text-primary-foreground hover:bg-blush-dark px-8 py-6 text-base font-medium rounded-full hover-lift shadow-glow"
                  onClick={() => window.open(PLANITY_URL, '_blank')}
                >
                  Jetzt Termin buchen
                </Button>
            </div>
            <div className="image-overlay rounded-2xl overflow-hidden shadow-soft-lg hover-pop">
              <img
                src={heroImage}
                alt="Friseur Haarstyling Balayage Nürnberg – 22 Studios"
                className="w-full h-64 md:h-80 lg:h-[500px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Herren */}
      <section className="py-12 md:py-28 relative z-10">
        <div className="container px-4 md:px-6">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-20 items-center">
            {/* Bilder links */}
            <div className="order-2 lg:order-1">
                <div className="grid grid-cols-2 gap-3 md:gap-4">
                  <div className="rounded-2xl overflow-hidden shadow-soft-lg hover-pop bg-muted aspect-[3/4]">
                    <img src={herrenSchnitt} alt="Männerhaarschnitt beim Friseur in Nürnberg – 22 Studios" className="w-full h-full object-cover object-center block" loading="lazy" width={400} height={533} />
                  </div>
                  <div className="rounded-2xl overflow-hidden shadow-soft-lg hover-pop mt-8 bg-muted">
                    <img src={herrenClipper} alt="Herrenhaarschnitt mit Clipper – Friseur Nürnberg" className="w-full aspect-[3/4] object-cover object-center block" loading="lazy" width={400} height={533} />
                  </div>
                  <div className="col-span-2 rounded-2xl overflow-hidden shadow-soft-lg hover-pop bg-muted">
                    <img src={barberStylist} alt="Barber und Herrenfriseur bei 22 Studios Nürnberg" className="w-full aspect-[16/9] object-cover object-[center_50%] block" loading="lazy" width={800} height={450} />
                  </div>
                </div>
            </div>

            {/* Text rechts */}
            <div className="order-1 lg:order-2 space-y-4 md:space-y-6">
              <div className="space-y-3 md:space-y-4">
                <span className="text-sm tracking-wide uppercase text-label font-medium">
                  Für Männer
                </span>
                <h2 className="text-heading md:text-display font-serif font-light text-foreground">
                  Haare &amp; Bart
                </h2>
              </div>
              <p className="text-base md:text-lg text-muted-foreground font-light leading-relaxed">
                {"Präzise Haarschnitte, cleane Fades und professionelle Bartpflege – abgestimmt auf deinen Style. Ob klassischer Herrenhaarschnitt, moderner Skin Fade oder Bart-Trimming: Bei uns bist du in besten Händen."}
              </p>
              {(
                <p className="text-sm text-muted-foreground font-light leading-relaxed">
                  Unser Barber-Team arbeitet mit hochwertigen Produkten und viel Liebe zum Detail.
                  Denn ein guter Haarschnitt ist mehr als nur Technik – er unterstreicht deine Persönlichkeit.
                </p>
              )}
              <div className="flex flex-wrap gap-2">
                {["Herrenhaarschnitt", "Fade", "Bart trimmen", "Bartpflege"].map((tag) => (
                  <span key={tag} className="px-3 py-1 text-xs font-medium rounded-full bg-secondary/50 text-muted-foreground border border-border/30">
                    {tag}
                  </span>
                ))}
              </div>
                <Button
                  size="lg"
                  className="bg-primary text-primary-foreground hover:bg-blush-dark px-8 py-6 text-base font-medium rounded-full hover-lift shadow-glow"
                  onClick={() => window.open(PLANITY_URL, '_blank')}
                >
                  Herren-Termin buchen
                </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-12 md:py-28 bg-secondary/30 relative z-10">
        <div className="container px-4 md:px-6">
          <div className="text-center mb-8 md:mb-16">
            <div className="flex items-center justify-center gap-4 mb-4 md:mb-6">
              <span className="w-12 h-px bg-primary" />
              <span className="text-sm tracking-wide uppercase text-label font-medium">Preise</span>
              <span className="w-12 h-px bg-primary" />
            </div>
            <h2 className="text-heading md:text-display font-serif font-light text-foreground">
              Friseur Preise – Haare schneiden, färben &amp; Balayage
            </h2>
          </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto">
              <div className="bg-background rounded-2xl p-5 md:p-8 shadow-soft hover-pop group">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/20 flex items-center justify-center group-hover:bg-primary/40 transition-colors">
                    <Scissors className="w-4 h-4 md:w-5 md:h-5 text-foreground" />
                  </div>
                  <h3 className="text-lg md:text-xl font-serif font-medium">Haarschnitt Damen</h3>
                </div>
                <ul className="space-y-2 md:space-y-4">
                  <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Kurz</span><span className="font-medium">39,50 €</span></li>
                  <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Mittel</span><span className="font-medium">48,50 €</span></li>
                  <li className="flex justify-between items-center py-2"><span className="text-muted-foreground text-sm">Lang</span><span className="font-medium">58,50 €</span></li>
                </ul>
              </div>

              <div className="bg-background rounded-2xl p-5 md:p-8 shadow-soft hover-pop group">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/20 flex items-center justify-center group-hover:bg-primary/40 transition-colors">
                    <Scissors className="w-4 h-4 md:w-5 md:h-5 text-foreground" />
                  </div>
                  <h3 className="text-lg md:text-xl font-serif font-medium">Damen</h3>
                </div>
                <ul className="space-y-2 md:space-y-4">
                  {damenPreiseNuernberg.map((p) => (
                    <li key={p.name} className="flex justify-between items-center py-2 border-b border-border/50 last:border-0">
                      <span className="text-muted-foreground text-sm">{p.name}</span>
                      <span className="font-medium">{p.price}</span>
                    </li>
                  ))}
                </ul>
                <p className="text-xs text-muted-foreground mt-3 md:mt-4">*je nach Aufwand</p>
              </div>

              <div className="bg-background rounded-2xl p-5 md:p-8 shadow-soft hover-pop group">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/20 flex items-center justify-center group-hover:bg-primary/40 transition-colors">
                    <Clock className="w-4 h-4 md:w-5 md:h-5 text-foreground" />
                  </div>
                  <h3 className="text-lg md:text-xl font-serif font-medium">Umformung</h3>
                </div>
                <ul className="space-y-2 md:space-y-4">
                  <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Keratin Glättung</span><span className="font-medium">ab 175 €*</span></li>
                  <li className="flex justify-between items-center py-2"><span className="text-muted-foreground text-sm">Extensions</span><span className="font-medium">je nach Aufwand</span></li>
                </ul>
                <p className="text-xs text-muted-foreground mt-3 md:mt-4">*je nach Aufwand</p>
              </div>

              <div className="bg-background rounded-2xl p-5 md:p-8 shadow-soft hover-pop group md:col-span-2 lg:col-span-3">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/20 flex items-center justify-center group-hover:bg-primary/40 transition-colors">
                    <Scissors className="w-4 h-4 md:w-5 md:h-5 text-foreground" />
                  </div>
                  <h3 className="text-lg md:text-xl font-serif font-medium">Extra Leistungen</h3>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
                  <div>
                    <h4 className="font-medium mb-3 md:mb-4 text-foreground text-sm md:text-base">Augenbehandlungen</h4>
                    <ul className="space-y-2 md:space-y-3">
                      <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Augenbrauen Farbe</span><span className="font-medium">9 €</span></li>
                      <li className="flex justify-between items-center py-2"><span className="text-muted-foreground text-sm">Wimpern Farbe</span><span className="font-medium">12 €</span></li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-medium mb-3 md:mb-4 text-foreground text-sm md:text-base">Warmwachs</h4>
                    <ul className="space-y-2 md:space-y-3">
                      <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Augenbrauen</span><span className="font-medium">12 €</span></li>
                      <li className="flex justify-between items-center py-2 border-b border-border/50"><span className="text-muted-foreground text-sm">Oberlippe/Kinn/Nase</span><span className="font-medium">je 6 €</span></li>
                      <li className="flex justify-between items-center py-2"><span className="text-muted-foreground text-sm">Gesicht komplett inkl. Augenbrauen</span><span className="font-medium">26 €</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          {/* CTA */}
          <div className="text-center mt-10 md:mt-16">
              <Button
                size="lg"
                className="bg-primary text-primary-foreground hover:bg-blush-dark px-10 py-6 text-base font-medium rounded-full hover-lift shadow-glow"
                onClick={() => window.open(PLANITY_URL, '_blank')}
              >
                Jetzt Termin buchen
              </Button>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default HaarePage;
